import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {getBalance, IParsedToken, logout} from "../../ducks/auth";
import {NavigationBar, NavigationBarDispatchProps, NavigationBarStateProps,} from "./navigationBar";
import {State} from "../../store/rootReducers";
import {sendTechnicalReport, setCommentPopupOpen, setUploadPopupOpen, updateTechReportText} from "../../ducks/upload";
import {selectHeader, selectPath} from "../../selectors/other";
import {getDifferenceRatioData, getToken, parseJwt} from "../../helper/other";
import {selectBalance} from "../../selectors/auth";
import {
    createHash,
    deleteTableRows,
    getExtendParams,
    getPdf, restartPackage,
    setDifferenceBarPosition,
    setExtendParams,
    setFirstDocumentPosition,
    setIsMagnifierActive,
    setLeftScale,
    setMenuOpen,
    setRightScale,
    setScrollSync,
    setZoomCount,
    updateDocFilterList,
    updatePairStatus
} from "../../ducks/montitoring";
import {
    selectDetailedPair,
    selectDifferenceBarPosition,
    selectDifferenceData,
    selectDocFilterList,
    selectFirstDocumentPosition,
    selectImageShapes,
    selectMagnifierAdded,
    selectMenuOpen,
    selectPairId,
    selectScrollSync,
    selectSelectedRowIds,
    selectZoomCount
} from "../../selectors/monitoring";
import {ROUTES} from "../../app/Routes";
import {popupPush} from "../../ducks/popup";
import {routeTo} from "../../ducks/baseCRUD";
import {selectComment, selectTechReportText} from "../../selectors/upload";
import {PageParts} from "../../ducks/types";

const mapStateToProps: MapStateToProps<NavigationBarStateProps, {}, State> = state => {
    let login = "";
    const path = selectPath(state, false);
    const pairId = selectPairId(state);
    const pathProcessed = selectPath(state);
    const panelPosition = selectDifferenceBarPosition(state);
    const docPosition = selectFirstDocumentPosition(state);
    const isPublic = pathProcessed === ROUTES.DocPublic;
    const isDetailedPage = pathProcessed === ROUTES.Doc || isPublic;
    const isListPage = path === ROUTES.Monitoring || path === ROUTES.Home;
    const token = getToken('user-info');
    const balance =  selectBalance(state);
    const differenceData = selectDifferenceData(state);
    const detailedPair = selectDetailedPair(state);
    const isVmAuth = path === ROUTES.Authorization;
    const imageShapes = selectImageShapes(state);

    let activeAccountId;
    let isUserInfo = false;
    if(token) {
        const parsedToken = parseJwt(token) as IParsedToken;
        if(parsedToken){
            login = parsedToken.FirstName;
            activeAccountId = parsedToken.ActiveAccountComparerId
            isUserInfo = true;
            try {
                window.localStorage.setItem('PyrusWebWidgetUserName', `ID организации: ${parsedToken.OrganizationId},${parsedToken.FirstName},${parsedToken.Mail}`)
            }
            catch {

            }
        }
    }
    const scrollSync = selectScrollSync(state);
    const techData = selectDetailedPair(state)?.techData
    const comment = selectComment(state);
    const docFilterList = selectDocFilterList(state);
    const filteredDiscrepancy: string[] = differenceData?.filter((el) => el.discrepancyElements && el.discrepancyElements.length > 0 && el.discrepancyElements.filter(discrepancy => docFilterList.includes(discrepancy)).length === 0).map(el => el.discrepancyElements).flat();

    return {
        docPosition,
        panelPosition,
        scrollSync,
        isDetailedPage,
        docFilterList: selectDocFilterList(state),
        isLoggedIn: !(path === "/auth"),
        login: login,
        header: selectHeader(state),
        balance: !isNaN(parseInt(balance)) ? parseInt(balance) : 0,
        menuOpen: selectMenuOpen(state),
        zoomCount: selectZoomCount(state),
        isMagnifierActive: selectMagnifierAdded(state),
        canGetBalance: !(path === ROUTES.Home) && !(path === ROUTES.Monitoring) ,
        isPublic,
        activeAccountId,
        isUserInfo,
        isListPage,
        selectedRowIds: selectSelectedRowIds(state),
        report: selectTechReportText(state),
        techData,
        pairId,
        comment,
        discrepancyRatio: detailedPair?.discrepancyRatio ?? null,
        differenceRatioData: getDifferenceRatioData(differenceData),
        filteredDiscrepancy,
        isVmAuth,
    };
};


const dispatchProps: MapDispatchToProps<NavigationBarDispatchProps, {}> = {
    onLogout: logout,
    setUploadPopupOpen,
    setScrollSync,
    getBalance,
    setMenuOpen,
    setDifferenceBarPosition,
    setFirstDocumentPosition,
    getPdf,
    setZoomCount,
    setIsMagnifierActive,
    updateDocFilterList,
    getExtendParams,
    setExtendParams,
    setLeftScale,
    setRightScale,
    popupPush,
    deleteTableRows,
    createHash,
    updatePairStatus,
    sendTechnicalReport,
    updateTechReportText,
    setCommentPopupOpen,
    routeTo: (route, id?) => {
        return routeTo(route, id)
    },
};

export const NavigationBarConnected = connect(
    mapStateToProps,
    dispatchProps,
)(NavigationBar);
